import React from 'react';
import styled from 'styled-components';
import {
  ChatIcon,
  BodyText,
  resetButtonStyle,
  BodyLink
} from '@kvdbil/components';
import { SupportChatCardRecord } from '~/config/generated/graphql';
import { useKundoChatToggle } from '~/App/shared/hooks/useKundoChatToggle';
import { useTranslation } from '~/Locale';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.background.lightGray};
  border: 2px solid ${({ theme }) => theme.colors.background.gray};
  border-radius: 0.5rem;
`;

const CtaButton = styled.button<{ $disabled: boolean }>`
  ${resetButtonStyle}
  display: flex;
  align-items: center;
  gap: 0.5rem;
  ${({ $disabled }) => $disabled && 'opacity: 0.5; cursor: not-allowed;'}
  width: fit-content;
`;

const CtaLabel = styled(BodyLink)`
  color: ${({ theme }) => theme.colors.info.dark};
`;

interface Props {
  record: SupportChatCardRecord;
}

const SupportChatCard = ({ record }: Props) => {
  const { t } = useTranslation();
  const { button, isChatOpen } = useKundoChatToggle();

  const handleOpenChat = () => {
    button?.click();
  };

  return (
    <Card>
      {record.text && <BodyText>{record?.text}</BodyText>}
      <CtaButton onClick={handleOpenChat} $disabled={isChatOpen}>
        <ChatIcon width={24} height={24} />
        <CtaLabel as="span">{record?.ctaLabel ?? t('Open chat')}</CtaLabel>
      </CtaButton>
    </Card>
  );
};

export default SupportChatCard;
